import React from 'react';
// ui imports
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
        cursor:'pointer',
      },
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    medium: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    large: {
        width: theme.spacing(20),
        height: theme.spacing(20),
    },
  }));

  export default function ProfilePhoto(props) {
    const classes = useStyles();
    let size, variant;

    switch(props.size) {
        case 'large':
            size = classes.large;
            break;
        case 'medium':
            size = classes.medium;
            break;
        case 'small':
        default:
            size = classes.small;
            break;
    }

    switch(props.variant) {
        case 'square':
            variant = "square";
            break;
        case 'rounded':
            variant = "rounded";
            break;
        default:
            variant = "circular";
            break;
    }
  
    return (
        <Grid item className={classes.root} 
            onClick={()=>document.location.href="/"}
        >
            <Avatar src={props.photo} 
                alt={props.name}
                variant={variant}
                className={size}
            />
        </Grid>
  );
}